import React, { useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import commImg from "./../../../assets/community.png";

function InvoiceZip() {
  const [hideSvg, setHideSvg] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalStartDate, setModalStartDate] = useState(null);
  const [modalEndDate, setModalEndDate] = useState(null);

  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDownload = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      toast.error("Authentication token not found. Please log in again.");
      return;
    }

    // Validate modal dates
    if (!modalStartDate && modalEndDate) {
      toast.error("Please select a start date.");
      return;
    }
    if (modalStartDate && modalEndDate && modalStartDate > modalEndDate) {
      toast.error("Start date cannot be after end date.");
      return;
    }

    // Construct URL with query parameters
    const queryParams = [];
    if (modalStartDate) {
      queryParams.push(`start_date=${formatDate(modalStartDate)}`);
    }
    if (modalEndDate) {
      queryParams.push(`end_date=${formatDate(modalEndDate)}`);
    }

    const url = `https://ballersapi.ballerslife.co/api/v1/admin/api/generate-invoices-zip?${
      queryParams.length > 0 ? queryParams.join("&") : ""
    }`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          const errorData = await response.json();
          throw new Error(
            errorData.detail || `HTTP error! Status: ${response.status}`
          );
        } else {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
      }

      const contentType = response.headers.get("content-type");
      if (!contentType || !contentType.includes("application/zip")) {
        throw new Error("Unexpected response format. Expected a ZIP file.");
      }

      // Get file name from Content-Disposition header
      let fileName = `invoices_${new Date()
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "")}.zip`;
      const disposition = response.headers.get("content-disposition");
      if (disposition && disposition.includes("attachment")) {
        const fileNameMatch = disposition.match(/filename="(.+)"/);
        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1];
        }
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

      toast.success("File downloaded successfully!");
      setIsModalOpen(false);
      setModalStartDate(null);
      setModalEndDate(null);
    } catch (err) {
      console.error("Error downloading file:", err);
      toast.error(
        err.message || "Failed to download the file. Please try again."
      );
    }
  };

  return (
    <div className="dashMain">
      <div className="sideBar">
        <Sidebar />
      </div>
      {hideSvg ? (
        <div className="sideBarMobile">
          <Sidebar />
        </div>
      ) : (
        <div></div>
      )}
      <div className="content">
        <div className="membership-container" style={{ marginTop: "15rem" }}>
          <span className="commImgContainer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#FFBF00"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="downloadIconExcelDownload"
              onClick={() => setIsModalOpen(true)}
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
          </span>
          <p className="commBannerHead">
            <button
              className="join-button"
              onClick={() => setIsModalOpen(true)}
            >
              Download
            </button>
          </p>
        </div>
        {isModalOpen && (
          <div className="modalExcelDownload">
            <div className="modalContentExcelDownload">
              <span
                className="closeModalExcelDownload"
                onClick={() => setIsModalOpen(false)}
              >
                ×
              </span>
              <h2 className="modalTitleExcelDownload">Download Invoice Data</h2>
              <div className="modalFieldExcelDownload">
                <label htmlFor="modal-start-date">Start Date:</label>
                <DatePicker
                  selected={modalStartDate}
                  onChange={(date) => setModalStartDate(date)}
                  dateFormat="yyyy-MM-dd"
                  placeholderText="Select start date"
                  className="datePickerModalExcelDownload"
                />
              </div>
              <div className="modalFieldExcelDownload">
                <label htmlFor="modal-end-date">End Date:</label>
                <DatePicker
                  selected={modalEndDate}
                  onChange={(date) => setModalEndDate(date)}
                  dateFormat="yyyy-MM-dd"
                  placeholderText="Select end date"
                  className="datePickerModalExcelDownload"
                />
              </div>
              <button
                className="downloadButtonExcelDownload"
                onClick={handleDownload}
              >
                Download Invoice
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default InvoiceZip;
